import apiClient from '../utils/apiClient';

export const fetchDevices = async () => {
  try {
    const response = await apiClient.get('/register/GetAll');
    return response.data.map(item => ({
      name: item.device.Name,
      uuid: item.device.uuid,
    }));
  } catch (error) {
    console.error('Error fetching devices:', error);
    throw new Error('Error fetching devices');
  }
};

export const getallDeviceWithRegisters = async () => {
  try {
    const response = await apiClient.get('/tag/taglist');
    return response.data;
  } catch (error) {
    console.error('Error fetching devices with registers:', error);
    throw new Error('Error fetching devices with registers');
  }
};

export const fetchRegisterByDevice = async deviceUuid => {
  try {
    const response = await apiClient.get('/register/GetAll');
    return response.data.filter(item => item.device.uuid === deviceUuid);
  } catch (error) {
    console.error(`Error fetching registers for device ${deviceUuid}:`, error);
    throw new Error(`Error fetching registers for device ${deviceUuid}`);
  }
};

export const postFilterReport = async ({
  begin,
  end,
  report_type,
  tag_uuids,
  pageNumber = 1,
  pageSize = 100,
}) => {
  try {
    const response = await apiClient.post('/Reports/Detailed', {
      begin: begin.toISOString(),
      end: end.toISOString(),
      report_type,
      tag_uuids,
      pageNumber,
      pageSize,
    });

    if (!response.data || Object.keys(response.data).length === 0) {
      return null;
    }

    return response.data;
  } catch (error) {
    console.error('Error posting filter report:', error);
    throw new Error('Error posting filter report');
  }
};

export const downloadReport = async (fileType, reportData) => {
  const { begin, end, report_type, tag_uuids } = reportData;

  try {
    const response = await apiClient.post(
      `/Reports/GetExcelReport?type=${fileType}`,
      {
        begin,
        end,
        report_type,
        tag_uuids,
      },
      {
        responseType: 'blob',
      }
    );

    const blob = new Blob([response.data], {
      type: response.headers['content-type'],
    });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `report.${fileType}`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  } catch (error) {
    console.error('Error downloading report:', error);
    throw new Error('Error downloading report');
  }
};
